<template>
  <div class="scanprdt-cnt">
    <div class="no-product" v-if="!getScannedProductDetails.length">
      <div class="no-item-found">
        <div class="img-block">
          <img src="../../assets/images/ic_product_box_add.svg" />
        </div>
        <div class="details-block">
          <p>अभी तक अपने कोई भी प्रोडक्ट स्कैन नहीं किया</p>
          <!-- <button type="button" class="ad-product" @click="addProduct()">+ प्रोडक्ट जोड़े</button> -->
        </div>
      </div>
    </div>
    <ul class="card-listing">
      <li v-for="(product_Item, index) in getScannedProductDetails">
        <span class="prdt-icon">
          <img
            v-if="product_Item.itemDTOList[0].itemMediaDTOList.length"
            :src="product_Item.itemDTOList[0].itemMediaDTOList[0].thumbnail"
            alt=""
          />
          <img src="../../assets/images/watermark1.jpg" alt="product" v-else />
        </span>

        <div class="prdt-info">
          <p>{{ product_Item.productName }}</p>
          <div class="price-block">
            <span class="update-price"
              >Rs. {{ product_Item.itemDTOList[0].mrp }}
            </span>
          </div>
        </div>

        <span @click="addScannedProduct(product_Item, index)" class="prdt-btn"
          >add to shop</span
        >
      </li>
    </ul>
    <div
      class="allshop-prdttab"
      @click="addAllToShops"
      v-if="getScannedProductDetails.length"
    >
      Add All Products
    </div>
    <CustomToaster :dataValue="toasterData" v-if="isToasterData" />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import ApiCaller from '@/utils/apicaller';
import constant from '@/utils/constant';
import CustomToaster from '../../components/Common/CustomToaster';

export default {
  name: 'ScanneProductList',
  data() {
    return {
      isToasterData: false,
      toasterData: {},
    };
  },
  components: {
    CustomToaster,
  },
  computed: {
    ...mapGetters(['getScannedProductDetails', 'getUserShopId']),
  },
  methods: {
    ...mapMutations(['updateScannedProduct']),
    addScannedProduct(product, index) {
      product.itemDTOList[0].sellerShopId = this.getUserShopId;
      ApiCaller(constant.CATALOGUE_URL, 'upload-product', 'post', product)
        .then((data) => {
          this.updateScannedProduct(index);
        })
        .catch((err) => {
          if (
            err.response.data.errorCodes[0] == 'ITEM_ALREADY_EXISTS_IN_SHOP'
          ) {
            this.toasterData = {
              msg: 'Item already exists in shop',
              color: '#e51c24',
              iconName: 'close',
            };
            this.isToasterData = true;
          } else {
            this.toasterData = {
              msg: 'Something went wrong',
              color: '#e51c24',
              iconName: 'close',
            };
            this.isToasterData = true;
          }
        });
    },
    addAllToShops() {
      this.getScannedProductDetails.map(
        (product) => (product.itemDTOList[0].sellerShopId = this.getUserShopId)
      );
      console.log(this.getScannedProductDetails);
      ApiCaller(
        constant.CATALOGUE_URL,
        'upload-bulk-product',
        'post',
        this.getScannedProductDetails
      )
        .then((data) => {
          this.$store.state.scannedProductDetails = [];
        })
        .catch((err) => {
          if (
            err.response.data.errorCodes[0] == 'ITEM_ALREADY_EXISTS_IN_SHOP'
          ) {
            this.toasterData = {
              msg: 'Item already exits in shop',
              color: '#e51c24',
              iconName: 'close',
            };
            this.isToasterData = true;
          } else {
            this.toasterData = {
              msg: 'Something went wrong',
              color: '#e51c24',
              iconName: 'close',
            };
            this.isToasterData = true;
          }
        });
    },
  },
};
</script>
